var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-idle',{attrs:{"duration":1800},on:{"idle":_vm.onidle}}),_vm._v(" "),(_vm.$store.getters.Paket==1)?_c('ChatWidget'):_vm._e(),_vm._v(" "),_c('KisaYol')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3df45111","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doc/Footer.vue
// module id = 532
// module chunks = 0